export const DEFAULT_PRICING_VERSION = "v2";

/** URL param that holds the open/closed state of the switch-to-yearly dialog. */
export const SWITCH_PLAN_MODAL_PARAM = "upgrade-interval";
